import { render } from "./End.vue?vue&type=template&id=17644a3e&scoped=true&bindings={\"scores\":\"data\"}"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import "./End.vue?vue&type=style&index=0&id=17644a3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17644a3e"

export default script